// extracted by mini-css-extract-plugin
module.exports = {"doc":"_12lVu","title":"_2_pV8"};